import React from 'react';
import { MapPin, Phone, Mail, Shield, Clock, Calendar, CheckCircle } from 'lucide-react';
export function ServiceArea() {
  return <section id="contact" className="py-16 bg-gradient-to-b from-[#F8F9FA] to-white" data-id="element-274">
      <div className="container mx-auto px-4" data-id="element-275">
        <div className="text-center mb-12" data-id="element-276">
          <div className="inline-flex items-center justify-center mb-4" data-id="element-277">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-10 h-10 mr-3" data-id="element-278" />
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B365D]" data-id="element-279">
              Service Area & Contact
            </h2>
          </div>
          <p className="text-[#2C3E50] text-lg max-w-3xl mx-auto" data-id="element-280">
            Crown Inspection Services proudly serves all of Southwest Florida,
            including Fort Myers, Naples, Cape Coral, Bonita Springs, Estero,
            Lehigh Acres, and surrounding areas.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-281">
          {/* Contact Information Card */}
          <div className="lg:col-span-2" data-id="element-282">
            <div className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-283">
              <div className="bg-[#1B365D] text-white p-6" data-id="element-284">
                <h3 className="text-2xl font-bold mb-2 flex items-center" data-id="element-285">
                  <Phone size={24} className="mr-3 text-[#D4AF37]" data-id="element-286" />
                  Contact Information
                </h3>
                <p className="text-gray-200" data-id="element-287">
                  We're available 7 days a week to answer your questions and
                  schedule inspections
                </p>
              </div>
              <div className="p-6" data-id="element-288">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-289">
                  <div className="flex items-start" data-id="element-290">
                    <div className="bg-[#F8F9FA] p-3 rounded-full mr-4" data-id="element-291">
                      <MapPin size={24} className="text-[#0077BE]" data-id="element-292" />
                    </div>
                    <div data-id="element-293">
                      <h4 className="font-bold text-[#1B365D] text-lg mb-1" data-id="element-294">
                        Location
                      </h4>
                      <p className="text-[#2C3E50]" data-id="element-295">Fort Myers, Florida</p>
                      <p className="text-gray-500 text-sm" data-id="element-296">
                        Serving all of SW Florida
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-297">
                    <div className="bg-[#F8F9FA] p-3 rounded-full mr-4" data-id="element-298">
                      <Phone size={24} className="text-[#0077BE]" data-id="element-299" />
                    </div>
                    <div data-id="element-300">
                      <h4 className="font-bold text-[#1B365D] text-lg mb-1" data-id="element-301">
                        Phone
                      </h4>
                      <a href="tel:2396997080" className="text-[#0077BE] text-lg font-medium hover:underline" data-id="element-302">
                        239-699-7080
                      </a>
                      <p className="text-gray-500 text-sm" data-id="element-303">
                        Available 7 days a week
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-304">
                    <div className="bg-[#F8F9FA] p-3 rounded-full mr-4" data-id="element-305">
                      <Mail size={24} className="text-[#0077BE]" data-id="element-306" />
                    </div>
                    <div data-id="element-307">
                      <h4 className="font-bold text-[#1B365D] text-lg mb-1" data-id="element-308">
                        Email
                      </h4>
                      <a href="mailto:Crowninspectionservices@gmail.com" className="text-[#0077BE] hover:underline break-words" data-id="element-309">
                        Crowninspectionservices@gmail.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-310">
                    <div className="bg-[#F8F9FA] p-3 rounded-full mr-4" data-id="element-311">
                      <Shield size={24} className="text-[#0077BE]" data-id="element-312" />
                    </div>
                    <div data-id="element-313">
                      <h4 className="font-bold text-[#1B365D] text-lg mb-1" data-id="element-314">
                        License Numbers
                      </h4>
                      <div className="grid grid-cols-3 gap-2" data-id="element-315">
                        <div className="bg-gray-100 rounded px-3 py-1 text-center text-gray-800 font-medium" data-id="element-316">
                          CGC1513193
                        </div>
                        <div className="bg-gray-100 rounded px-3 py-1 text-center text-gray-800 font-medium" data-id="element-317">
                          HI2954
                        </div>
                        <div className="bg-gray-100 rounded px-3 py-1 text-center text-gray-800 font-medium" data-id="element-318">
                          MRSA2278
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-[#F8F9FA] border-t border-gray-200 p-4 flex items-center" data-id="element-319">
                <Clock size={20} className="text-[#0077BE] mr-3" data-id="element-320" />
                <p className="text-gray-600" data-id="element-321">
                  For urgent inspections, please call us directly for same-day
                  or next-day availability.
                </p>
              </div>
            </div>
          </div>
          {/* CTA and Emergency Notice */}
          <div className="lg:col-span-1 space-y-8" data-id="element-322">
            {/* Urgent Inspection CTA */}
            <div className="bg-gradient-to-br from-[#1B365D] to-[#0F2A4A] text-white rounded-xl shadow-xl p-6 relative overflow-hidden" data-id="element-323">
              <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-324">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-full h-full" data-id="element-325" />
              </div>
              <h3 className="text-2xl font-bold mb-4 flex items-center" data-id="element-326">
                <Calendar size={24} className="text-[#D4AF37] mr-3" data-id="element-327" />
                Need an Inspection ASAP?
              </h3>
              <p className="mb-6 text-gray-200" data-id="element-328">
                We understand that sometimes you need an inspection on short
                notice. Call us directly for same-day or next-day availability.
              </p>
              <a href="tel:2396997080" className="flex items-center justify-center bg-[#D4AF37] hover:bg-[#C09F2F] text-[#1B365D] py-3 px-6 rounded-lg font-bold transition-colors duration-200 w-full shadow-lg" data-id="element-329">
                <Phone size={18} className="mr-2" data-id="element-330" />
                Call 239-699-7080
              </a>
            </div>
            {/* Emergency Notice */}
            <div className="bg-[#FFF9E6] border-l-4 border-[#D4AF37] rounded-lg p-4 shadow-md" data-id="element-331">
              <div className="flex items-start" data-id="element-332">
                <div className="bg-[#D4AF37] text-[#1B365D] p-2 rounded-full mr-4 flex-shrink-0" data-id="element-333">
                  <Phone size={20} data-id="element-334" />
                </div>
                <div data-id="element-335">
                  <h4 className="font-bold text-[#1B365D]" data-id="element-336">
                    Emergency Inspection Available
                  </h4>
                  <p className="text-sm text-[#2C3E50]" data-id="element-337">
                    Need an urgent inspection for a closing? Call us directly at
                    <a href="tel:2396997080" className="text-[#0077BE] font-bold hover:underline" data-id="element-338">
                      {' '}
                      239-699-7080
                    </a>
                    for priority scheduling.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}